var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: [_vm.isManage && "manage"] },
    _vm._l(_vm.nodes, function(node, index) {
      return _c(
        "li",
        {
          key: index,
          style: "margin-left: " + (node.level > 1 ? "35px" : "0px") + ";"
        },
        [
          node.type == "account"
            ? _c(
                "div",
                {
                  staticClass: "wrapper-item",
                  class: [(_vm.isManage ? "manage" : "view") + "-" + node._id],
                  on: {
                    click: function($event) {
                      return _vm.clickNode(node)
                    },
                    mouseover: function($event) {
                      return _vm.onMouseover(node)
                    },
                    mouseleave: function($event) {
                      return _vm.onMouseleave(node)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "account" }, [
                    node.children
                      ? _c(
                          "div",
                          { staticClass: "icon" },
                          [
                            node.is_group
                              ? [
                                  node.open
                                    ? _c("i", {
                                        staticClass: "far fa-folder-open"
                                      })
                                    : _c("i", { staticClass: "far fa-folder" })
                                ]
                              : [_c("i", { staticClass: "far fa-file-alt" })]
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(node.account_code) +
                          "\n          -\n          " +
                          _vm._s(
                            _vm.getMasterDataText(node.account_name, _vm.$t)
                          ) +
                          "\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  (function() {
                    if (_vm.isManage) {
                      return false
                    }
                    if (node.open) {
                      if (node.level > 1) {
                        return false
                      }
                    }
                    return true
                  })()
                    ? _c("div", { staticClass: "balance" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.getNumber(node.balance)) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          node.type == "action" && _vm.isManage
            ? _c(
                "div",
                { staticClass: "wrapper-action my-2" },
                [
                  _c(
                    "BaseButton",
                    {
                      staticClass: "btn-sm",
                      on: {
                        click: function($event) {
                          return _vm.addGroup(node)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        + " +
                          _vm._s(_vm.$t("apps.accounting.button.addgroup")) +
                          "\n        "
                      ),
                      _c("i", { staticClass: "far fa-folder" })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "BaseButton",
                    {
                      staticClass: "btn-sm",
                      on: {
                        click: function($event) {
                          return _vm.addAccount(node)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        + " +
                          _vm._s(_vm.$t("apps.accounting.button.addaccount")) +
                          "\n        "
                      ),
                      _c("i", { staticClass: "far fa-file-alt" })
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          node.children && node.open
            ? _c("TreeItem", {
                attrs: {
                  master: _vm.master,
                  nodes: node.children,
                  isManage: _vm.isManage
                },
                on: {
                  onClickNode: function(node) {
                    return _vm.$emit("onClickNode", node)
                  },
                  onAddGroup: _vm.addGroup,
                  onAddAccount: _vm.addAccount,
                  onToggleNode: function(node) {
                    return _vm.$emit("onToggleNode", node)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67c46f6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c46f6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/TreeItem.vue
// module id = null
// module chunks = 